import { render, staticRenderFns } from "./stockDetail.vue?vue&type=template&id=8e0c797a&scoped=true&"
import script from "./stockDetail.vue?vue&type=script&lang=js&"
export * from "./stockDetail.vue?vue&type=script&lang=js&"
import style0 from "./stockDetail.vue?vue&type=style&index=0&id=8e0c797a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0c797a",
  null
  
)

export default component.exports